
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_g9v3m_im8v7_5"
};
  